import { Mail, MessageCircle, Package, Phone, Printer, Radio, Store, Tag } from 'lucide-react';

/**
 * Die Sinnbilder, die ein Bestellweg tragen kann (A40).
 *
 * WARUM DIE LISTE HIER STEHT UND NICHT DREIMAL
 *   Sie stand zweimal: in BestellwegPicker.tsx und in QuelleIcon.tsx,
 *   Zeichen für Zeichen gleich. Die Einstellungen wären die dritte
 *   Kopie geworden — und die erste, die etwas anbietet, was die
 *   anderen beiden vielleicht nicht kennen. Wer hier ein Sinnbild
 *   wählen kann, das der Picker nicht kennt, sieht danach überall den
 *   Anhänger und findet keinen Grund dafür (Fallstrick 15).
 *
 * DER SCHLÜSSEL IST DER SPALTENWERT. In `bestellwege.icon` steht genau
 * dieser Text; er kommt aus der Datenbank und nicht aus dem Programm.
 * Kennt das Programm ihn nicht, gilt der Anhänger — kein Absturz.
 */
export const BESTELLWEG_ICONS = [
  { code: 'phone', name: 'Telefon', Icon: Phone },
  { code: 'radio', name: 'Funk', Icon: Radio },
  { code: 'printer', name: 'Drucker', Icon: Printer },
  { code: 'mail', name: 'Brief', Icon: Mail },
  { code: 'store', name: 'Laden', Icon: Store },
  { code: 'message-circle', name: 'Nachricht', Icon: MessageCircle },
  { code: 'package', name: 'Paket', Icon: Package }
] as const;

/** Der Rückfall: ein Anhänger, wenn kein Sinnbild gesetzt oder bekannt ist. */
export const BESTELLWEG_ICON_FALLBACK = Tag;

/** Das Sinnbild zu einem Spaltenwert — oder der Anhänger. */
export function bestellwegIcon(code: string | null | undefined): typeof Tag {
  if (!code) return BESTELLWEG_ICON_FALLBACK;
  return BESTELLWEG_ICONS.find((i) => i.code === code)?.Icon ?? BESTELLWEG_ICON_FALLBACK;
}
